export default __webpack_public_path__ + "static/media/icon-file-add.1bdf51c1.svg";